import IWantItAll from './IWantItAll'

export default IWantItAll